import { Pipe, PipeTransform, inject } from '@angular/core';

import { Requests } from 'src/providers/requests/requests';

@Pipe({ name: 'requestTimeRangeList', standalone: true, pure: true })
export class RequestTimeRangeListPipe implements PipeTransform {
  private requests = inject(Requests);

  transform(timeBlocks: any[]): any[] {
    return this.requests.buildRequestTimeRangeList(timeBlocks);
  }
}
